// extracted by css-extract-rspack-plugin
export default {"list":"list-MbCJM2","item":"item-u8TQj0","info":"info-NTV1Vv"};